// extracted by css-extract-rspack-plugin
export default {"header":"Vg7iPbFW2chUIIVC"};